<div
  *ngIf="!(isEnabled() | async) && !isHighlight"
  class="disabled-outline"
  [ngClass]="{
    'dialog-button': typeOfButton === ButtonOutline[0],
    'project-action-button': typeOfButton === ButtonOutline[1]
  }"
></div>
<button
  (click)="onClick($event)"
  [disabled]="!(isEnabled() | async)"
  [ngClass]="{
    'highlighted-outline-button': isHighlight,
    'outline-button': !isHighlight,
    'dialog-button': typeOfButton === ButtonOutline[0],
    'project-action-button': typeOfButton === ButtonOutline[1],
    disabled: !(isEnabled() | async)
  }"
>
  <div>
    <span class="button-title">{{ getTitle() | translate }}</span>
    <span *ngIf="hotButton">({{ hotButton }})</span>
  </div>
</button>
